import { service as request } from '@/request/index';
import { newTerminalInfo, detectBrowser,getCookie } from '@/utils/browser.js';
import { logmapUrl,apiKey } from '../common';
import axios from 'axios'  
export function getTreeList(id, per_page, page) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-details' : '/index-species-index';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            per_page: per_page,
            page: page,
        }
    })
}
export function getSpeciesDetails(id) {
    return request({
        method: 'get',
        url: '/api/index-species-info/' + id
    })
}
//首页
export function getLiterature(id, per_page, page, title, author, year, doi, keyword, journal) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-getliteraturelist' : '/index-species-getliteraturelist';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            title,
            author,
            year,
            doi,
            keyword,
            journal,
            per_page: per_page,
            page
        }
    })
}

//literature页面
export function getliteraturelist(per_page, page, title, author, year, doi, keyword, journal) {
    return request({
        method: "post",
        url: "/api/index-literature-index",
        data: {
            page: page,
            per_page: per_page,
            keywords: '',
            order_name: '',
            order_value: 0,
            r_doi: doi,
            r_author: author,
            r_joint_author: '',
            r_year: year,
            r_title: title,
            r_keywords: keyword,
            r_journal: journal
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export function getLiteratureDetails(id) {
    return request({
        method: "get",
        url: "/api/index-literature-index/" + id
    })
}
export function getCit(id) {
    return request({
        method: 'get',
        url: '/api' + '/index-literature-cite/' + id
    })
}
export function getSpecies(id, per_page, page) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-getsonlist' : '/index-species-getsonlist';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            per_page: per_page,
            page
        }
    })
}


export function getGallery(id, per_page, page) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-gallery' : '/index-species-gallery';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            per_page: per_page,
            page
        }
    })
}
//首页获取markers
export function getFossillist(id) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-getfossillist' : '/index-species-getfossillist';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            per_page: 10,
            page: 1
        }
    })
}

export function getAllLocations(id) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-specimens-all-locations' : '/index-species-specimens-all-locations';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            top: 20000

        }
    })
}
export function getAllPoints() {
    return request({
        method: "get",
        url: 'https://geo.datav.aliyun.com/areas_v3/bound/540000_full.json'
    })
}
export function getFossilGps(id, per_page, page) {
    let url = '/new-api/get-fossil-gps' + ((id != null && id != '') ? '?s_id=' + id : '');
    return request({
        method: 'get',
        url: url,
        params: {
            // top:20000,
            per_page: per_page,
            page: page,
            latitude_min: '20',
            latitude_max: '45',
            longtitude_min: '65',
            longtitude_max: '105'

        }
    })
}
//specimens的详细信息
export function getFossilDetails(fossil_id) {
    return request({
        method: "get",
        url: '/api/index-fossil-fossil_details/' + fossil_id
    })
}
export function getGlossary(keyword, indexkey, per_page, page) {
    let url = (keyword ? (keyword ? '/indexkeyword/' + keyword : '') : (indexkey ? '/indexkey/' + indexkey : '')) + '/index-anatomical-index'
    return request({
        method: "get",
        url: '/api' + url,
        params: {
            per_page: per_page,
            page
        }
    })
}
export function getGlossaryDetails(id) {
    return request({
        method: "get",
        url: '/api/index-anatomical-details/' + id
    })
}
//点击specimens的tab使用此api
export function getSpecimens(id, per_page, page) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-specimens' : '/index-species-specimens';
    return request({
        method: 'get',
        url: '/api' + url,
        params: {
            per_page: per_page,
            page
        }
    })
}

export function updateSpecimens(id, ids) {
    let url = (id != null && id != '') ? '/id/' + id + '/index-species-specimens2' : '/index-species-specimens2';
    return request({
        method: 'post',
        url: '/api' + url,
        data: {
            fossil_ids: ids.toString()
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export function getTopSearch(per_page, page, keywords) {
    return request({
        method: "post",
        url: "/api/index-top-search",
        data: {
            page: page,
            per_page: per_page,
            keyword: keywords
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}


export function getDownloadList(data) {
    return request({
        method: 'post',
        url: '/api/download',
        data: {
            ...data,
            genus: ''
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export function download(data) {
    return request({
        method: 'put',
        url: '/api/download/0',
        data: {
            ...data
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        responseType: 'blob'
    })
}

export function postToEmail(data) {
    return request({
        method: 'post',
        url: '/api/download-task',
        data: {
            ...data
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export async function utlogMap(data) {
    let browser = detectBrowser();
    let preUrl = sessionStorage.getItem('preUrl');
    let sendData = Object.assign({}, {
        userId: 'guest',//deepbone没有用户登陆
        cookieId: getCookie('sessionId'),
        clientType: newTerminalInfo(),
        lang: localStorage.getItem('locale') || 'en-US',
        url: '',
        preUrl: preUrl,
        functionId: '',
        eventType: 'clk',
        channel: 'deepbone',
        // userAgent: browser.browser,
        uuid: localStorage.getItem("uuid"),
        env: (process.env.NODE_ENV == 'production')?'prod':'dev'
    }, data)
    sendData.utlogMap = JSON.stringify(sendData.utlogMap)
    let api_key = getCookie('api-key');//使用的插件生成的cookie,api-key是主动添加的，由于没有使用插件的pageopen等事件，因此需要自己添加api-key和更新preUrl
    return axios({
        method: 'post',
        url: logmapUrl,
        headers:{
            'Content-Type': 'application/json',
            'Dde-Ananlytics-Utlog-Api-Key':api_key
        },
        data: sendData
    })
}
